import { FormattedMessage } from 'react-intl';

export const intlPrefix = 'registerWatchBanner';

export const Subheading = (
  <FormattedMessage
    defaultMessage='We use blockchain to give you extra security'
    id='pdp.registerWatchBanner.subheading'
  />
);

export const Description = (
  <FormattedMessage
    defaultMessage='Register now to become a member and benefit from exclusive services. Breitling brings you also a private and unique digital passport, a digital certificate of ownership securely linked to your Breitling watch through blockchain technology.'
    id='pdp.registerWatchBanner.description'
  />
);

export const RegisterLink = (
  <FormattedMessage
    defaultMessage='Register a new watch'
    id='pdp.registerWatchBanner.RegisterLink'
  />
);
